import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import { LoadingService } from '../../loading.service';
import { SnackService } from '../../snack.service';
import { Observable } from 'rxjs';
import { _post } from '../../base.service';

@Injectable({
  providedIn: 'root',
})
export class TourInstallerResetNotExecutedControllerRequestService {
  private static BASE_URL = '/tourInstaller/resetNotExecuted';
  private readonly post: <T>(
    path: string,
    body: null,
    deserialize: (response: any) => T
  ) => Observable<T>;

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post(
      TourInstallerResetNotExecutedControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public resetNotExecuted(subProjectId: number): Promise<string> {
    return this.post(
      `/${subProjectId}`,
      null,
      GeneralHelper.identity
    ).toPromise();
  }
}
